import { useMutation, useQuery, useQueryClient, keepPreviousData } from '@tanstack/react-query';
import { getUsers, deleteUser, inviteUser } from '../../../../services/clientUsers';

export const teamMembersQueryKeys = {
  all: ['teamMembers'],
  list: (params) => [...teamMembersQueryKeys.all, 'list', params],
};

export function useTeamMembersQuery({ page = 1, pageSize = 10 } = {}) {
  return useQuery({
    queryKey: teamMembersQueryKeys.list({ page, pageSize }),
    queryFn: () => getUsers({ page, pageSize }),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}

export function useDeleteUser({ onSuccess, onError } = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUser,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: teamMembersQueryKeys.all });
      onSuccess?.(data, variables);
    },
    onError,
  });
}

export function useInviteUser({ onSuccess, onError } = {}) {
  return useMutation({
    mutationFn: inviteUser,
    onSuccess,
    onError,
  });
}
